import { Business, PeopleAlt } from "@mui/icons-material";
import { Card, CardContent, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

interface OverviewProps {
    totalTenants: number;
    totalParticipants: number;
}

const StyledCard = styled(Card)(({ theme }) => ({
    backgroundColor: theme.palette.info.main,
    color: 'white',
    borderRadius: theme.spacing(2),
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    transition: '0.3s',
    width: '40%',
    minHeight: '200px',
    margin: '1%',
    '&:hover': {
        boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
    },

}));
const Title = styled(Typography)({
    marginBottom: '16px',
});

const Text = styled(Typography)({
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
});

const Icon = styled('span')({
    marginRight: '8px',
});

const Overview: React.FC<OverviewProps> = ({ totalTenants, totalParticipants }) => {
    const [t] = useTranslation("global");
    return (
        <StyledCard>
            <CardContent>
                <Title variant="h6" fontWeight="bold">{t('homeoverview.t1')}</Title>
                <Text>
                    <Icon><Business /></Icon>
                    {t('homeoverview.t2')} {totalTenants}
                </Text>
                <Text>
                    <Icon><PeopleAlt /></Icon>
                    {t('homeoverview.t3')} {totalParticipants}
                </Text>
            </CardContent>
        </StyledCard>
    );
};

export default Overview;